import { groq } from "next-sanity"

import { AppSettings } from "@/settings"

import { checkPermissions } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"

/**
 * Deletes (or soft deletes) the complaint
 */
export const mutationDeleteComplaint = {
  async deleteComplaint(parent, args, context, info) {
    const { lang = AppSettings.defaultLocale(), cdn = true, id } = args

    const { user } = context

    await checkPermissions({
      user,
      domainObject: DomainObjects.COMPLAINTS,
      operation: Operations.DELETE,
    })

    const config = AppSettings.sanityConfigByLang(lang)
    const client = context.sanityClient
    client.config({ ...config, useCdn: cdn })

    const draftsFilter = `&& !(_id in path("drafts.**"))`

    try {
      // make sure complaint exists and the id is actually of type complaint
      const complaint = await client.fetch(groq`*[_type=="complaint" && _id==$id ${draftsFilter}][0] {...}`, {
        id: id,
      })

      if (!complaint) return null

      const deleteComplaint = await client.delete(id)

      if (!deleteComplaint) return null

      return true
    } catch (error) {
      console.warn("Error deleting complaint", error)
      return null
    }
  },
}
